import { CommunitySearchType, LoyaltyPlanSearchType, SearchSubType, SearchType, TransactionSearchType } from "./Enums";

export class SearchModel {

    public constructor(init?: Partial<SearchModel>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    searchType: SearchType = SearchType.Pops;
    searchSubType: SearchSubType;
    searchText: string;
    paging: PagingModel;
}

export class PagingModel {

    public constructor(init?: Partial<PagingModel>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    pageSize: number;
    page: number;
}

export class TransactionSearchModel
{
    public constructor(init?: Partial<TransactionSearchModel>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    type: TransactionSearchType = TransactionSearchType.All;
    paging: PagingModel;
}


export class CommunitySearchModel
{
    public constructor(init?: Partial<CommunitySearchModel>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    type: CommunitySearchType = CommunitySearchType.All;
    paging: PagingModel;
}

export class LoyaltyPlanSearchModel
{
    public constructor(init?: Partial<LoyaltyPlanSearchModel>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    type: LoyaltyPlanSearchType = LoyaltyPlanSearchType.All;
    paging: PagingModel;
}
